import { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Swal from "sweetalert2";
import * as zy from '../../common/zeroyear-1.0.0';
let sessionStorage = window.sessionStorage;

export default function Pricing () {
    const [admin, setAdmin] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [estmteList, setEstmteList] = useState([]);
    const [showModalPw, setShowModalPw] = useState(false);
    const [clickEst, setClickEst] = useState(null);
    const [myPw, setMyPw] = useState('');

    const selectAll = () => {
        zy.select('selectEstmteMain', [],(item) => {
            setEstmteList(item);
            setLoading(false);
        });
    };
    useEffect(()=>{
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    },[]);

    /**
     * close modal pw
     */
    const closeModalPw = () => {
        setShowModalPw(false);
        setClickEst('');
        setMyPw('');
    };
    /**
     * open modal pw
     */
    const openModalPw = () => {
        setShowModalPw(true);
    };
    /**
     * my 비밀번호 change event
    */
    const changeMyPw = (event) => {
        setMyPw(event?.target.value);
    }
    /**
     * check click pw
     */
    const checkPw = (event) => {
        let seq = event.target.getAttribute('data-seq')
        let est = estmteList.find((o) => o.ESTMTE_SEQ == seq);
        setClickEst(est);
        let url = '';
        if (est.ESTMTE_DV === '10') {
            url = 'SurveyEstimateDetailRoute';
        } else if (est.ESTMTE_DV === '20') {
            url = 'DesignEstimateDetailRoute';
        }
        if (admin) {
            navigate(`/${url}/${est.ESTMTE_SEQ}`);
            event.preventDefault();
            event.stopPropagation();
        } else {
            openModalPw();
        }
    };
    /**
     * confirm my pw
     */
    const checkMyPw = () => {
        let url = '';
        if (clickEst.ESTMTE_DV === '10') {
            url = 'SurveyEstimateDetailRoute';
        } else if (clickEst.ESTMTE_DV === '20') {
            url = 'DesignEstimateDetailRoute';
        }
        if (clickEst.ESTMTE_PW === myPw) {
            navigate(`/${url}/${clickEst.ESTMTE_SEQ}`);
        } else {
            Swal.fire({
                icon: "error",
                text: "비밀번호가 일치하지 않습니다.",
            }).then((res) => {
                if (res.isConfirmed) { }
                else{ }
            });
        }
    }

    return (
        <section id="pricing" className="pricing">
        <div className="container">
            <div className="section-title">
                <span>최근 견적문의</span>
                <h2>최근 견적문의</h2>
                {/* <p>Sit sint consectetur velit quisquam cupiditate impedit suscipit alias</p> */}
            </div>
            <Table responsive="sm">
                <thead>
                    <tr>
                        {/* <th style={{width: '100px'}}>번호</th> */}
                        <th style={{width: '150px'}}>분류</th>
                        <th style={{width: '400px'}}>제목</th>
                        <th style={{width: '180px'}}>작성자</th>
                        <th style={{width: '280px'}}>작성일시</th>
                        <th style={{width: '100px'}}>답변</th>
                    </tr>
                </thead>
                <tbody>
                {/* {ESTMTE_DV: '10', ESTMTE_REG_NM: '', ESTMTE_PW: '', ESTMTE_TITLE: '', ESTMTE_CONTENT: '', REG_DTM} */}

                {/* SurveyEstimateDetailRoute DesignEstimateDetailRoute */}

                {estmteList.length == 0 ? (<tr><td style={{ textAlign: 'center' }} colSpan={6}>등록된 문의글이 없습니다.</td></tr>) 
                : estmteList.map((est) => (
                    // let url
                    <tr key={est.ESTMTE_SEQ}>
                        {/* <td style={{width: '100px'}}>{est.ESTMTE_NO}</td> */}
                        <td style={{width: '150px'}}>{est.ESTMTE_DV == '10' ? '측량' : '설계'}</td>
                        <td style={{width: '400px'}}><Link data-seq={est.ESTMTE_SEQ} onClick={checkPw}>{est.ESTMTE_TITLE}</Link></td>
                        <td style={{width: '180px'}}>{est.ESTMTE_REG_NM}</td>
                        <td style={{width: '280px'}}>{est.REG_DTM}</td>
                        <td style={{width: '100px'}}>{est.RE_COMP_YN === 'Y' ? '답변완료' : '미답변'}</td>
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
        <Modal 
            show={showModalPw}
            onHide={closeModalPw}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered>
            <Modal.Header closeButton>
            <Modal.Title>비밀번호</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="d-input mb-3" controlId="ESTMTE_PW">
                    <Form.Label>비밀번호</Form.Label>
                    <Form.Control
                        type="password"
                        onChange={changeMyPw}
                        placeholder="비밀번호 입력 (8~12)"
                        maxLength={12}
                        required
                    />
                    <Form.Control.Feedback type="invalid">비밀번호를 입력해주세요.</Form.Control.Feedback>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn-cancel" onClick={closeModalPw}>닫기</button>
                <button className="btn-normal" type="button" onClick={checkMyPw}>확인</button>
            </Modal.Footer>
        </Modal>
        </section>
    );
}